import React from 'react';
import './CustomCommonScreenHeader.css';
import { CustomCommonScreenHeaderType } from './types/CustomCommonScreenHeaderType';
import { CustomButton } from '@/shared/components/atoms';
import { Plus } from 'lucide-react';

/**
 * CustomCommonScreenHeader Component
 * A reusable header for all screens, typically used after the breadcrumb.
 * Displays an icon, title, subtitle, and an optional action button.
 */
export const CustomCommonScreenHeader: React.FC<CustomCommonScreenHeaderType> = ({
    title,
    subtitle,
    icon,
    actionLabel,
    onActionClick,
    actionIcon = <Plus size={18} />,
    secondaryActionLabel,
    onSecondaryActionClick,
    secondaryActionIcon,
    className = ''
}) => {
    return (
        <div className={`custom-screen-header ${className}`}>
            <div className="header-left">
                {icon && <div className="header-icon-container">{icon}</div>}
                <div className="header-text">
                    <h1 className="header-title">{title}</h1>
                    {subtitle && <p className="header-subtitle">{subtitle}</p>}
                </div>
            </div>
            <div className="header-right" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                {secondaryActionLabel && (
                    <CustomButton
                        onClick={onSecondaryActionClick}
                        className="header-action-btn header-action-btn--secondary"
                        borderRadius="50px"
                        variant="outline"
                        color="secondary"
                    >
                        {secondaryActionIcon}
                        <span>{secondaryActionLabel}</span>
                    </CustomButton>
                )}
                {actionLabel && (
                    <CustomButton
                        onClick={onActionClick}
                        className="header-action-btn header-action-btn--primary"
                        borderRadius="50px"
                    >
                        {actionIcon}
                        <span>{actionLabel}</span>
                    </CustomButton>
                )}
            </div>
        </div>
    );
};

export default CustomCommonScreenHeader;
